module.exports = __webpack_public_path__ + "static/media/duetigli-ronco.58456aeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/duetigli-ronco.png
// module id = 793
// module chunks = 0